import { render, staticRenderFns } from "./SectionTemplate.vue?vue&type=template&id=f064c6c0&"
import script from "./SectionTemplate.vue?vue&type=script&lang=js&"
export * from "./SectionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports